<div class="container-fluid home-full-page">
  <div class="content-align">
    <div class="row w3-container w3-animate-opacity w3-center w3-animate-top">
      <div class="col-12 text-center mb-5">
        <h1 class="home-content-banner">Sumant Mishra</h1>
        <h2 class="home-content-banner">Passionate Web developer</h2>
      </div>
    </div>
    <div class="row">
      <div
        class="mb-3 mb-md-5 col-12 col-md-6 text-center text-md-right w3-animate-opacity w3-container w3-animate-left"
      >
        <button
          (click)="scrollPage('contact')"
          class="hire-me-btn rounded py-1 py-md-3 text-center w-50"
          type="button"
        >
          Hire Me
        </button>
      </div>
      <div
        class="mb-3 mb-md-5 col-12 col-md-6 text-center text-md-left w3-animate-opacity w3-container w3-animate-right"
      >
        <div>
          <button
            (click)="scrollPage('about')"
            class="hire-me-btn rounded py-1 py-md-3 text-center w-50"
            type="button"
          >
            Learn More
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div
        class="col-12 mt-3 mt-md-0 mb-md-5 w3-center w3-animate-opacity w3-container w3-animate-bottom"
      >
        <a (click)="scrollPage('portfolio')"
          ><i
            class="angle-down-icon rounded-circle p-2 fa fa-angle-down fa-3x"
            aria-hidden="true"
          ></i
        ></a>
      </div>
    </div>
  </div>
</div>
